PopoverEventEmitter = function () {};
heir.inherit(PopoverEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
PopoverEventEmitter.prototype.addListener = function (name, action, listener) {
    AppEventEmitter.prototype.addListener.call(this, (name + '.' + action), listener);
};
// noinspection JSCheckFunctionSignatures
PopoverEventEmitter.prototype.emitEvent = function (name, action, args) {
    AppEventEmitter.prototype.emitEvent.call(this, ('*' + '.' + action), [ args ]);
    if (name !== '*') {
        AppEventEmitter.prototype.emitEvent.call(this, (name + '.' + action), [ args ]);
    }
};

app.popover = new PopoverEventEmitter();
app.popover.SHOW = 'show';
app.popover.SHOWN = 'shown';
app.popover.HIDE = 'hide';
app.popover.HIDDEN = 'hidden';
app.popover.INSERTED = 'inserted';

app.popover.on('*', app.popover.SHOW, function () {
    $(document.body).find('[data-bs-toggle="tooltip"]').each(function () {
        var instance = bootstrap.Tooltip.getInstance($(this)[0]);
        if (instance) {
            instance.dispose();
        }
    });
});

$(function () {
    $('html, body').on('click', function (e) {
        $('[data-bs-toggle="popover"]').each(function () {
            if (!$(this).is(e.target)
                && !$(this).has(e.target).length
                && !$('.popover').has(e.target).length
            ) {
                var instance = bootstrap.Popover.getInstance($(this)[0]);
                if (instance && !$(this).data('bs-disposable')) {
                    instance.hide();
                }
            }
        });
    });
});
